<div class="donor-content">
  <div class="flex-container-row">
    <div class="donor-img-container">
      <span *ngIf="!donorObject?.avtar && !isDefaultUser" class="donor-img-placeholder">{{donorObject?.initials| uppercase}}</span>
      <i *ngIf="isDefaultUser" class="icon-user1"></i>
      <img loading="lazy" class="donor-img" [hidden]="!(donorObject?.avtar && !isDefaultUser)" [attr.data-src]="cdn" [alt]="'Donor - ' + donorObject?.name" />
    </div>
    <div class="donor-date donor-name-container">
      <span class="d-name">
        <span class="donor-title" *ngIf="title">{{title}}</span>
        <span class="donor-name align-middle">{{donorObject?.name}}</span>
      </span>
      <div *ngIf="showTime && donorObject?.creation_date" class="donor-date date-time">{{donorObject?.creation_date | dayjs:'to'}}</div>
    </div>
  </div>
  <div *ngIf="donorObject?.donated_amount && donor" class="donor-amt">
    <!-- <mat-icon *ngIf="donorObject.currencyInfo.is_symbol" class="donor-icon" [ngClass]="donorObject.currencyInfo.icon"></mat-icon>
    <span *ngIf="!donorObject.currencyInfo.is_symbol">{{donorObject.currencyInfo.icon}}</span> -->
    <app-currency-icon *ngIf="donor?.iso_currency" [currency]="donor?.iso_currency"></app-currency-icon>
    {{(donorObject?.donated_amount || donorObject?.raised) | inrFormat:donor?.iso_currency}}
  </div>
</div>